// @ts-nocheck
import formatDate from "includes/formatDate";
import genRequest from "includes/request";

class WorkFamilyObject {

	#companyId = null;
	#workFamilyId = null;
	#workFamilyName = null;
	#lastChanged = formatDate();
	#lastChangeAuthorId = null;

	constructor (props)
	{
		this.#companyId = props?.companyId || null;
		this.#workFamilyId = props?.id || props?.workFamilyId || null;
		this.#workFamilyName = props?.workFamilyName || props?.name || "";
		this.#lastChanged = props?.lastChanged || formatDate();
		this.#lastChangeAuthorId = props?.lastChangeAuthorId || null;
	}

	send = () => {
		let that = this;
		let isNew = !(this.#workFamilyId > 0);
		let prom = new Promise((resolve, reject) => {
			let req = that.sendWfam().then(() => {
				if (isNew)
					return (that.linkToCompany());
				resolve(that.values());
				return (that.values());
			}, reject).then(() => {
				resolve (that.values());
				return (that.values());
			}, reject);
			return (req);
		});
		return (prom);
	};

	sendWfam = () => {
		let datas = {
			companyId: this.#companyId,
			workFamilyName: this.#workFamilyName,
		};
		if (this.#workFamilyId)
			datas.workFamilyId = this.#workFamilyId;
		let req = genRequest(
			"work-families" + (this.#workFamilyId ? "/" + this.#workFamilyId : ""),
			datas,
			(this.#workFamilyId ? "put" : "post")
		).then((resp) => {
			if (!this.#workFamilyId)
			{
				this.#companyId = resp.companyId;
				this.#workFamilyId = resp.id || resp.workFamilyId;
				this.#workFamilyName = resp.workFamilyName || resp.name;
				this.#lastChangeAuthorId = resp.lastChangeAuthorId;
				this.#lastChanged = resp.lastChanged;
			}
		});
		return (req);
	};

	linkToCompany = () => {
		let req = genRequest(
			"work-families/" + this.#workFamilyId + "/link-company",
			{
				companyId: this.#companyId
			},
			"post"
		);
		return (req);
	};

	id = () => this.#workFamilyId;

	name = (setName) => {
		if (typeof setName !== "undefined")
			this.#workFamilyName = setName;
		return (this.#workFamilyName);
	};

	lastChanged = () => this.#lastChanged;

	lastChangeAuthorId = () => this.#lastChangeAuthorId;

	values = () => ({
		companyId: this.#companyId,
		workFamilyId: this.#workFamilyId,
		workFamilyName: this.#workFamilyName,
		lastChanged: this.#lastChanged,
		lastChangeAuthorId: this.#lastChangeAuthorId
	});
}

export default WorkFamilyObject;
